import { render, staticRenderFns } from "./page-header.vue?vue&type=template&id=0d888df1&"
import script from "./page-header.component.ts?vue&type=script&lang=ts&"
export * from "./page-header.component.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/kevinmathieu/crr-sl-fr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d888df1')) {
      api.createRecord('0d888df1', component.options)
    } else {
      api.reload('0d888df1', component.options)
    }
    module.hot.accept("./page-header.vue?vue&type=template&id=0d888df1&", function () {
      api.rerender('0d888df1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/app/fo/components/page-header/page-header.vue"
export default component.exports